import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { required, TRequiredCodec } from "../../shared/src/codecs/types/required";
import { union } from "../../shared/src/codecs/types/union";
import { nullCodec, TNullCodec } from "../../shared/src/codecs/types/nullCodec";
import { dateTime, TAnyDateTimeCodec } from "../../shared/src/codecs/types/dateTime";
import { string, TAnyStringCodec } from "../../shared/src/codecs/types/string";
import { TUnionCodec } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { nonEmptyString } from "../../shared/src/codecs/types/nonEmptyString";
import { integer } from "../../shared/src/codecs/types/integer";
import { integerFromString } from "../../shared/src/codecs/types/integerFromString";

export const AuthenticatorStatus: TRequiredCodec<{
    confirmed_at: TUnionCodec<[TAnyDateTimeCodec, TNullCodec]>;
}> = required({
    confirmed_at: union([dateTime(), nullCodec()]),
});
export type TAuthenticatorStatusCodec = typeof AuthenticatorStatus;
export type TAuthenticatorStatus = TTypeOfCodec<TAuthenticatorStatusCodec>;

// The only shape carrying the secret: shown once, at enrolment, and never again.
export const AuthenticatorEnrolmentOffer: TRequiredCodec<{
    secret: TAnyStringCodec;
    otpauth_uri: TAnyStringCodec;
    qr_data_uri: TAnyStringCodec;
}> = required({
    secret: string(),
    otpauth_uri: string(),
    qr_data_uri: string(),
});
export type TAuthenticatorEnrolmentOfferCodec = typeof AuthenticatorEnrolmentOffer;
export type TAuthenticatorEnrolmentOffer = TTypeOfCodec<TAuthenticatorEnrolmentOfferCodec>;

// last_used_step is a bigint, which node-postgres hands back as a string.
export const AuthenticatorRow = required({
    id: uuid(),
    secret: nonEmptyString(),
    confirmed_at: union([dateTime(), nullCodec()]),
    last_used_step: union([integerFromString(), integer(), nullCodec()]),
});
export type TAuthenticatorRowCodec = typeof AuthenticatorRow;
export type TAuthenticatorRow = TTypeOfCodec<TAuthenticatorRowCodec>;

export const AuthenticatorOwnerRow = required({
    company: nonEmptyString(),
    staff_email: union([nonEmptyString(), nullCodec()]),
    crm_username: union([nonEmptyString(), nullCodec()]),
});
export type TAuthenticatorOwnerRowCodec = typeof AuthenticatorOwnerRow;
export type TAuthenticatorOwnerRow = TTypeOfCodec<TAuthenticatorOwnerRowCodec>;

export const SmsAuthCodeRow = required({
    id: uuid(),
    two_factor_auth_code: string(),
    two_factor_last_sent: union([dateTime(), nullCodec()]),
});
export type TSmsAuthCodeRowCodec = typeof SmsAuthCodeRow;
export type TSmsAuthCodeRow = TTypeOfCodec<TSmsAuthCodeRowCodec>;
